/**
 * @file Sticky Header.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Sticky Header component.
 */
const vStickyHeader = () => {
	const stickyHeader = document.querySelector('.v-sticky-header');

	if (!stickyHeader) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	gsap.to(stickyHeader, {
		y:        0,
		yPercent: 0,
		ease:     'sine.out',
		duration: 0.3,
		onStart:  () => {
			gsap.set(stickyHeader, { display: 'block' });
			const event = new CustomEvent('v-sticky-header-toggle', { detail: { stuck: true } });
			document.dispatchEvent(event);
		},
		onComplete: () => {
			stickyHeader.classList.add('v-sticky-header--stuck');
			gsap.set(stickyHeader, { clearProps: 'all' });
		},
		onReverseComplete: () => {
			stickyHeader.classList.remove('v-sticky-header--stuck');
			gsap.set(stickyHeader, { clearProps: 'all' });
		},
		scrollTrigger: {
			trigger:       '.v-header',
			start:         'bottom top',
			end:           '+=1px',
			toggleActions: 'play none none reverse',
			onLeaveBack:   () => {
				const event = new CustomEvent('v-sticky-header-toggle', { detail: { stuck: false } });
				document.dispatchEvent(event);
			},
		},
	});

	const navTrigger = stickyHeader.querySelector('.v-sticky-header__nav-trigger');
	navTrigger.addEventListener('click', () => {
		const event = new CustomEvent('v-mobile-nav-toggle', { detail: { open: true } });
		document.dispatchEvent(event);
	});
};

export default vStickyHeader;
